import React from 'react';

import { Tooltip } from '@material-ui/core';

import { images } from 'assets';
import { BasicThreeDotsMenu } from 'components/shared';
import i18n from 'i18n-js';
import { helperFunctions } from 'helpers';
import { useStyles } from '../styles';
import { CookColumnSort } from 'constants/enums';

interface SectionHeaderProps {
    title?: string;
    containerId?: string;
    amount?: number;
    withPlus?: boolean;
    sorting?: CookColumnSort;
    onSortClick: (val: CookColumnSort) => void;
    threeDotItems?: JSX.Element[];
}

export default function SectionHeader({
    title = 'Some Title',
    containerId,
    amount = 0,
    withPlus,
    sorting = CookColumnSort.None,
    onSortClick,
    threeDotItems,
}: SectionHeaderProps) {
    const classes = useStyles();

    function filterButton(text: string, active: boolean, i: CookColumnSort) {
        return (
            <div
                onClick={() => onSortClick(i)}
                className={`${classes.filterButton} ${
                    active ? classes.activeFilterButton : classes.passiveFilterButton
                }`}
            >
                <span
                    className={
                        active ? classes.activeFilterButtonText : classes.passiveFilterButtonText
                    }
                >
                    {text}
                </span>
            </div>
        );
    }

    function hasFilterAndAmount() {
        return sorting !== CookColumnSort.None && amount > 0;
    }

    return (
        <div
            id={containerId}
            style={{ minHeight: hasFilterAndAmount() ? 109 : 63, maxHeight: 142 }}
            className={classes.sectionHeaderContainer}
        >
            <div className={classes.flexRowSpaceBetween}>
                <div className={classes.flexRow}>
                    <span className={classes.sectionHeaderText}>{title} </span>
                    <span className={classes.mHorizontal5}>{' /'} </span>
                    <span className={classes.sectionHeaderText}>{amount}</span>
                </div>
                <div className={classes.flexRow}>
                    {withPlus && (
                        <img
                            src={images.icons.circlePlus}
                            alt="circle-plus"
                            className={classes.mRight20}
                        />
                    )}
                    <BasicThreeDotsMenu items={threeDotItems} />
                </div>
            </div>
            {hasFilterAndAmount() && (
                <div className={`${classes.flexRowSpaceBetween} ${classes.filterButtonContainer}`}>
                    <div>
                        <Tooltip title={i18n.t('common.order')}>
                            {filterButton(
                                helperFunctions.truncateLangString(i18n.t('common.order'), 8),
                                sorting === CookColumnSort.Order,
                                CookColumnSort.Order
                            )}
                        </Tooltip>
                    </div>
                    <div>{filterButton(i18n.t('common.dish'), sorting === CookColumnSort.Name, CookColumnSort.Name)}</div>
                    <div>{filterButton(i18n.t('common.qr'), sorting === CookColumnSort.QR, CookColumnSort.QR)}</div>
                    <div>{filterButton(i18n.t('common.course'), sorting === CookColumnSort.Course, CookColumnSort.Course)}</div>
                </div>
            )}
        </div>
    );
}
